import { Component, OnInit, Input } from '@angular/core';
import { DATA_PER_PAGE } from '@root/app.constant';
import { DigitalFactsheet } from '../catalogue-digital-factsheet.model';
import { CatalogService } from '@catalog/catalog.service';
import { CommonDataService } from '@shared/catalogue/services/common-data.service';
import { ErrorHandler } from '@root/utils/error-handler.service';

@Component({
  selector: 'app-catalog-digital-factsheet-list',
  templateUrl: './catalog-digital-factsheet-list.component.html',
  styleUrls: ['./catalog-digital-factsheet-list.component.scss']
})
export class CatalogDigitalFactsheetListComponent implements OnInit {
  @Input() data: DigitalFactsheet[]= [];

  pageSize: number = DATA_PER_PAGE;

  constructor(private catalogService : CatalogService, private commonDataService: CommonDataService,  private errorHandler: ErrorHandler) { }

  ngOnInit() {
  }

  public onDelete(item: any){
      this.commonDataService.confirm('Are you sure want to delete?', 'md').then((confirmed)=>{
        if (confirmed){
          this.catalogService.deleteDigitalFactsheet({ "id" : item.id }).subscribe(
            response => {
              if(response.status === 0){
                  this.readDigitalFactsheet(item)
              }
            },
            error => {}
          )
        }
      })
  }

  public readDigitalFactsheet(data) {
    const obj = {
      year : data.year ? data.year : ''
    };
    this.catalogService.readDigitalFactsheet(obj).subscribe(
      (response) => {
        if(response.status === 0){
          this.data = response.data.digitalFactsheetReturnValue;
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }


}
